import { createContext } from "react";

const DF_LO0020Context = createContext();

export { DF_LO0020Context };